// Global (document-level) listener must only be bound once no matter how
// many <mobile-menu> instances exist on the page - otherwise a single click
// on the header's hamburger button would dispatch the toggle event once per
// instance.
let globalMobileMenuListenersBound = false;

function bindGlobalMobileMenuListeners() {
  if (globalMobileMenuListenersBound) return;
  globalMobileMenuListenersBound = true;

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-mobile-menu-toggle]')) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('mobilemenu:toggle'));
    }
  });
}

class MobileMenu extends HTMLElement {
  connectedCallback() {
    bindGlobalMobileMenuListeners();

    this.lastFocused = null;
    const desktopQuery = window.matchMedia('(min-width: 768px)');

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-mobile-menu-close]')) this.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.hidden) this.close();
    });

    document.addEventListener('mobilemenu:toggle', () => {
      if (this.hidden) this.open();
      else this.close();
    });

    desktopQuery.addEventListener('change', (event) => {
      if (event.matches) this.close();
    });
  }

  open() {
    this.lastFocused = document.activeElement;
    this.hidden = false;
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('header-mobile-menu-open');
    document.dispatchEvent(new CustomEvent('mobilemenu:open'));
    this.querySelector('.mobile-menu__panel')?.focus();
  }

  close() {
    this.hidden = true;
    document.body.style.overflow = '';
    document.documentElement.classList.remove('header-mobile-menu-open');
    document.dispatchEvent(new CustomEvent('mobilemenu:close'));
    if (this.lastFocused) this.lastFocused.focus();
  }
}

// Guarded because this file can legitimately be requested by more than one
// section on the same page - re-registering the same tag name throws.
if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu);
}
